<div class="date-picker-container" fxLayout="row" fxLayoutAlign="space-around center">
  <mat-icon
    *ngIf="showArrows"
    (click)="dateSwitchFunc('previous')"
    [class.disabled]="isMinDateReached"
    aria-hidden="false"
    class="arrow"
  >
    keyboard_arrow_left
  </mat-icon>

  <div
    class="date-picker"
    [ngClass]="{
      'boxed-arrows': showArrows && boxedArrows,
      'plain-arrows': showArrows && !boxedArrows,
    }"
    (click)="dp.open()"
  >
    <mat-form-field>
      <input
        (dateChange)="dateIsPicked($event)"
        [formControl]="date"
        [matDatepicker]="dp"
        [min]="minDate"
        [max]="maxDate"
        matInput
      />
      <mat-datepicker
        #dp
        disabled="false"
        [dateClass]="dateClass"
        panelClass="example-month-picker"
        startView="year"
      ></mat-datepicker>
      <mat-icon aria-hidden="false" class="calendar"> today </mat-icon>
    </mat-form-field>
  </div>

  <mat-icon
    id="next-week"
    *ngIf="showArrows"
    (click)="dateSwitchFunc('next')"
    [class.disabled]="isMaxDateReached"
    aria-hidden="false"
    class="arrow"
  >
    keyboard_arrow_right
  </mat-icon>
</div>
